'use client'

import { ArrowLeft } from 'lucide-react'
import { FC, useState } from 'react'

export type WideBackButtonProps = {
  onClick: () => void
}

/**
 * ワイド型の「← 前の動画へ」。2本目以降の動画で、再生が始まった時から左上に出し続け、動画が終わっても残す。
 * 押すと1つ前の動画の頭に戻る（縦型のボックス型・ポップアップ型の「前の動画へ」と同じ役割）。
 *
 * 動画が終わってから初めて出すボタンにはしない（ADR-0023 の「再生後の画面で別の動画へ進ませない」）。
 * 終了画面の中に「最初の動画へ」なども足さない。
 */
const WideBackButton: FC<WideBackButtonProps> = ({ onClick }) => {
  const [isHovered, setIsHovered] = useState(false)
  return (
    <button
      type="button"
      data-testid="wide-back-button"
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '7px 12px 7px 10px',
        border: '1px solid rgba(255,255,255,0.25)',
        borderRadius: '999px',
        // 目次ボタンと同じ地の色。マウスを乗せたら目次の行と同じく黒く沈める
        background: isHovered ? 'rgba(0,0,0,0.8)' : 'rgba(8,18,38,0.78)',
        transition: 'background 0.15s',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 700,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        backdropFilter: 'blur(8px)',
      }}
    >
      <ArrowLeft size={14} style={{ flexShrink: 0 }} />
      前の動画へ
    </button>
  )
}

export default WideBackButton
